define.alias("shared/components/shared/post/profile-selector/available-profile", "settings/components/shared/post/profile-selector/available-profile/index");